import React from 'react';
import './LockIndicator.css';

const LockIndicator = ({ lockedAt, startedAt }) => {
    const isLocked = lockedAt && new Date() >= new Date(lockedAt);

    // Calculate time remaining until lock (7 days from when user started)
    const getTimeRemaining = () => {
        if (!startedAt) return null;

        const started = new Date(startedAt);
        const lockTime = new Date(started.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days later
        const now = new Date();
        const remaining = lockTime - now;

        if (remaining <= 0) return null;

        const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

        if (days > 0) {
            return `${days}d ${hours}h`;
        }
        return `${hours}h`;
    };

    const timeRemaining = getTimeRemaining();

    if (isLocked) {
        return (
            <div className="lock-indicator locked">
                <div className="lock-icon">🔒</div>
                <div className="lock-content">
                    <div className="lock-title">Form Locked (Partial Edit)</div>
                    <div className="lock-message">
                        This form was locked on {new Date(lockedAt).toLocaleString()}.
                        <br />
                        <strong>You can still edit:</strong> Mood emojis (😊😐☹️) and notes fields.
                        <br />
                        Other fields cannot be modified.
                    </div>
                </div>
            </div>
        );
    }

    if (timeRemaining) {
        return (
            <div className="lock-indicator warning">
                <div className="lock-icon">⏱️</div>
                <div className="lock-content">
                    <div className="lock-title">Editing Window</div>
                    <div className="lock-message">
                        {/* You have 6d 23h remaining to edit this form before it is locked */}
                        You have <strong>{timeRemaining}</strong> remaining to edit this form before it is locked.
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

export default LockIndicator;
